const { createElement, formatMoney } = window.BAO.Utils

class CharmsForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.uploadInput = this.querySelector(
      '[data-personalisation-file-upload-el="input"]',
    )

    this.uploadError = this.els.uploadError?.element

    this.selectedCharms = []

    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.get('updating') === '1') {
      document.querySelector('.prd-Charms_ControlsContainer').style.display =
        'block'
    }
  }

  connectedCallback () {
    super.connectedCallback()

    try {
      const data = JSON.parse(this.els.data.element.innerText)
      this.productProps = data.product
      this.configurationProps = data.configurations
      this.maxCharms = this.getMaxCharms(data.configurations)
      this.minCharmsPrice = data.minCharmsPrice || 0
      this.fromLabel = this.dataset.fromLabel || 'From'
    } catch {
      console.error('Error parsing personalisation props')
      return
    }

    this.selectedVariant = this.productProps.variants.find(
      (variant) => variant.id === parseInt(this.els.variantId.element.value),
    )

    this.createCanvasElememnts()
  }

  setupListeners () {
    this.els.charm?.elements.forEach((charmEl) => {
      this.listeners.add(charmEl, 'click', this.handleCharmAdd.bind(this))
    })

    this.listeners.add(
      this.els.addToCart.element,
      'click',
      this.handleATCClick.bind(this),
    )

    if (this.els?.termsCheckbox?.exists) {
      this.listeners.add(
        this.els.termsCheckbox.element,
        'change',
        this.handleTermsCheckbox.bind(this),
      )
    }

    this.els.viewImage?.elements.forEach((viewImage) => {
      this.listeners.add(
        viewImage,
        'click',
        this.handleViewImageClick.bind(this),
      )
    })

    this.els.swatch?.elements.forEach((swatch) => {
      this.listeners.add(swatch, 'click', this.handleSwatchClick.bind(this))
    })

    this.els.tab?.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.handleTabClick.bind(this))
    })

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PDP.VARIANT_CHANGED,
      this.handleVariantChange.bind(this),
    )

    document.addEventListener(
      'visualiser:reorder',
      this.handleCharmReorder.bind(this),
    )

    document.addEventListener(
      'preview:reorder',
      this.handlePreviewReorder.bind(this),
    )

    document.addEventListener(
      'preview:remove',
      this.handleCharmRemove.bind(this),
    )

    this.els.x?.elements.forEach((el) => {
      this.listeners.add(el, 'change', this.updateCharmPosition.bind(this))
    })
    this.els.y?.elements.forEach((el) => {
      this.listeners.add(el, 'change', this.updateCharmPosition.bind(this))
    })
    this.els.rotation?.elements.forEach((el) => {
      this.listeners.add(el, 'change', this.updateCharmPosition.bind(this))
    })
  }

  updateCharmPosition (e) {
    const {
      value,
      name,
      dataset: { configurationIndex, placementIndex },
    } = e.target

    this.configurationProps[configurationIndex].placements[placementIndex][
      name
    ] = value

    this.charmsCanvas.render()
  }

  handleCharmAdd (e) {
    const { currentTarget } = e

    if (this.selectedCharms.length >= this.maxCharms) return

    const charmData = JSON.parse(currentTarget.dataset.charm || '')

    if (!charmData) return

    this.selectedCharms.push(charmData)

    this.updateCharms()
  }

  handleCharmRemove (e) {
    const { detail } = e

    this.selectedCharms.splice(parseInt(detail.index), 1)

    this.updateCharms()
  }

  handleCharmReorder (e) {
    this.selectedCharms = e.detail.charms

    this.updateCharmPreview(true, true)
    this.updateCharmInputs()
  }

  handlePreviewReorder (e) {
    this.selectedCharms = e.detail.charms

    this.updateCharmPreview(true, false)
    this.updateCharmInputs()
  }

  updateCharms () {
    this.charmsCanvas.charms = this.selectedCharms
    this.charmsCanvas.configuration = this.currentConfiguration

    this.previewCanvas.charms = this.selectedCharms

    if (this.selectedCharms.length === this.currentConfiguration.charmCount) {
      this.els.charmCountError?.element.setAttribute('aria-hidden', true)
    }

    this.updateCharmCount()
    this.updateCharmList()
    this.updateCharmPreview(true, true)
    this.updateCharmInputs()
    this.updatePrices()
    this.updateAddToCartButton()
    this.togglePreviewDragMessage()
  }

  togglePreviewDragMessage () {
    const dragMessage = this.externalEls.dragMessage?.element
    if (!dragMessage) return

    dragMessage.setAttribute('aria-hidden', this.selectedCharms.length < 2)
  }

  updateCharmCount () {
    const charmCount = this.els.charmCount?.element

    if (!charmCount) return

    charmCount.innerText = this.selectedCharms.length
  }

  updateCharmList () {
    this.querySelectorAll('.prd-CharmItem[aria-selected="true"]').forEach(
      (el) => {
        el.setAttribute('aria-selected', false)
        el.querySelector('.prd-CharmItem_Count').innerText = 0
      },
    )

    this.selectedCharms.forEach((charm) => {
      const el = this.querySelector(`[data-charm-id='${charm.id}']`)
      el.setAttribute('aria-selected', true)
      el.querySelector('.prd-CharmItem_Count').innerText =
        this.selectedCharms.filter((c) => c.id === charm.id).length
    })

    this.els.tab?.elements.forEach((tab) => {
      const charmContainer = this.els.charmType?.elements.find(
        (el) => el.dataset.charmType === tab.dataset.charmType,
      )
      const countEl = tab.querySelector('.prd-Charms_CharmTabCount')

      const totalSelected = Array.from(
        charmContainer.querySelectorAll(
          '.prd-CharmItem[aria-selected] .prd-CharmItem_Count',
        ),
      ).reduce((total, count) => total + parseInt(count.innerText), 0)

      countEl.innerText = totalSelected
      countEl.setAttribute('aria-hidden', totalSelected === 0)
    })
  }

  updateCharmPreview (renderVisualiser, renderPreview) {
    if (renderPreview) {
      this.previewCanvas.render()
    }

    if (renderVisualiser) {
      this.generatePreview(renderVisualiser)
    }
  }

  updateCharmInputs () {
    const container = this.els.charmInputContainer?.element

    if (!container) return

    container.innerHTML = ''

    this.selectedCharms.forEach((charm, index) => {
      container.appendChild(
        createElement('input', {
          type: 'hidden',
          name: `items[${index + 1}][id]`,
          value: charm.id,
        }),
      )

      container.appendChild(
        createElement('input', {
          type: 'hidden',
          name: `items[${index + 1}][parent_id]`,
          value: this.selectedVariant.id,
        }),
      )
    })
  }

  handleSwatchClick (e) {
    e.preventDefault()

    const { currentTarget } = e

    const selectedColour = currentTarget.dataset.colour

    this.els.swatch?.elements.forEach((swatch) => {
      swatch.setAttribute(
        'aria-selected',
        swatch.dataset.colour === selectedColour,
      )
    })

    this.els.charmContainer?.elements.forEach((charm) => {
      charm.setAttribute(
        'aria-hidden',
        charm.dataset.colour !== selectedColour,
      )
    })

    if (this.els.currentMetal?.element) {
      this.els.currentMetal.element.innerText = selectedColour
    }
  }

  handleTabClick (e) {
    e.preventDefault()

    const { currentTarget } = e

    const selectedType = currentTarget.dataset.charmType

    this.els.tab?.elements.forEach((tab) => {
      tab.setAttribute('aria-selected', tab.dataset.charmType === selectedType)
    })

    this.els.charmType?.elements.forEach((charm) => {
      charm.setAttribute(
        'aria-hidden',
        charm.dataset.charmType !== selectedType,
      )
    })
  }

  handleVariantChange (e) {
    const parentVariant = e.detail?.variant?.data
    if (!parentVariant) {
      return
    }

    const matchingVariant = this.productProps.variants.find(
      (v) => v.id === parentVariant.id,
    )

    if (!matchingVariant) {
      return
    }

    this.selectedVariant = matchingVariant
    this.updateVariantId(parentVariant, matchingVariant)
    this.updateAvailabilityState(parentVariant, matchingVariant)
    this.updateStatusContainers(parentVariant, matchingVariant)
    this.updatePrices()
  }

  findMatchingVariant (variant, product) {
    if (this.isServiceProduct) {
      return this.productProps.variants[0]
    }

    const matchingVariant = product.variants.find((v) => {
      return (
        v.option1 === variant.option1 &&
        v.option2 === variant.option2 &&
        v.option3 === variant.option3
      )
    })

    return matchingVariant
  }

  updateVariantId (parentVariant, variant) {
    this.els.variantId.element.value = this.isServiceProduct
      ? parentVariant.id
      : variant.id
  }

  updateAvailabilityState (variant) {
    const available = variant.available

    this.querySelector('[data-product-form]').dataset.productAvailable =
      available

    this.updateAddToCartButton()
  }

  updateStatusContainers (variant) {
    this.els.status.element.setAttribute('data-available', variant.available)

    this.els.statusValue?.elements.forEach((el) => {
      const value = variant[`option${el.dataset.option}`]
      if (value) {
        el.innerText = value
      }
    })
  }

  updatePrices () {
    const variant = this.selectedVariant

    const hasSelectedCharms = this.selectedCharms.length > 0
    const productPrice = variant.price
    const charmsPrice = hasSelectedCharms
      ? this.selectedCharms.reduce((total, charm) => total + charm.price, 0)
      : this.minCharmsPrice

    const priceTotal = productPrice + charmsPrice
    const showFromLabel = !hasSelectedCharms && this.minCharmsPrice > 0

    this.els.price?.elements.forEach((el) => {
      el.dataset.price = priceTotal
      el.innerText = showFromLabel
        ? `${this.fromLabel} ${formatMoney(priceTotal)}`
        : formatMoney(priceTotal)
    })

    this.updateLoyaltyLion(variant, priceTotal)
    this.updateKlarna(priceTotal)
    this.updateClearpay(priceTotal)
  }

  updateLoyaltyLion (variant, price) {
    const loyaltyElement = document.querySelector('[data-product-loyalty]')
    const loyaltyPrice = loyaltyElement.querySelector(
      '[data-lion-price-for-product-id]',
    )
    const loyaltyPoints = loyaltyElement.querySelector(
      '[data-lion-points-for-product-id]',
    )

    if (loyaltyPrice) {
      loyaltyPrice.dataset.lionPriceForProductId = variant.id
      loyaltyPrice.innerText = formatMoney(price)
    }

    if (loyaltyPoints) {
      loyaltyPoints.dataset.lionPointsForProductId = variant.id
    }

    if (window.loyaltylion) {
      window.loyaltylion?.ui?.refresh()
    }
  }

  updateKlarna (price) {
    const klarnaElement = document.querySelector('klarna-placement')
    if (!klarnaElement) return

    klarnaElement.dataset.purchaseAmount = price

    if (window.Klarna?.OnsiteMessaging) {
      window.Klarna?.OnsiteMessaging.on('placementRendered', () => {
        klarnaElement.dataset.purchaseAmount = parseInt(price)
      })
    }
  }

  updateClearpay (price) {
    const clearpayElement = document.querySelector('square-placement')
    if (!clearpayElement) return

    clearpayElement.setAttribute('data-amount', (price / 100).toFixed(2))
    clearpayElement.refresh?.()
  }

  updateAddToCartButton () {
    const productAvailable =
      this.querySelector('[data-product-form]').dataset.productAvailable ===
      'true'

    const productHandle = this.productProps.handle

    const atcButton = this.els.addToCart.element
    const bisButton = this.els.backInStock.element

    atcButton.ariaHidden = !productAvailable
    bisButton.ariaHidden = productAvailable

    bisButton.dataset.productUrl = `/products/${productHandle}?variant=${this.els.variantId.element.value}`
  }

  handleATCClick (e) {
    const visibleError = this.querySelector(
      '[data-charms-form-el="error"][aria-hidden="false"]',
    )

    if (visibleError) {
      this.scrollToElement(visibleError)
      e.preventDefault()
      return false
    }

    if (this.selectedCharms.length !== this.currentConfiguration.charmCount) {
      const charmCountError = this.els.charmCountError?.element

      if (charmCountError) {
        charmCountError.setAttribute('aria-hidden', false)

        this.scrollToElement(charmCountError)
        e.preventDefault()
        return false
      }
    }

    const termsValid =
      !this.els?.termsCheckbox?.exist || this.els.termsCheckbox.element.checked

    if (!termsValid) {
      const termsError = this.els.termsError.element

      if (termsError) {
        termsError.setAttribute('aria-hidden', false)
        this.scrollToElement(termsError)
        e.preventDefault()
        return false
      }
    }
  }

  scrollToElement (error) {
    const yOffset = document.querySelector('.hd-Header').clientHeight
    const y =
      error.parentElement.getBoundingClientRect().top +
      window.scrollY -
      yOffset -
      10
    window.scrollTo({
      top: y,
      behavior: 'smooth',
    })
  }

  handleTermsCheckbox (e) {
    const termsError = this.els.termsError.element
    termsError.setAttribute('aria-hidden', e.target.checked)
  }

  handleViewImageClick (e) {
    e.preventDefault()
    const targetId = e.target.href.split('#')[1]
    if (!targetId) return

    const target = document.getElementById(targetId)
    if (!target) return

    this.scrollToElement(target)
  }

  createCanvasElememnts () {
    this.charmsCanvas = new CharmsCanvas()
    this.charmsCanvas.charms = this.selectedCharms
    this.charmsCanvas.configuration = this.currentConfiguration
    this.charmsCanvas.render()

    this.previewCanvas = new PreviewCanvas()
    this.previewCanvas.charms = this.selectedCharms
    this.previewCanvas.render()
  }

  async generatePreview (render) {
    if (render) {
      this.charmsCanvas.render(this.configurationProps, this.selectedCharms)
    }
  }

  getMaxCharms (configurations) {
    const sortedConfigurations = configurations.sort(
      (a, b) => a.charmCount - b.charmCount,
    )
    return sortedConfigurations[sortedConfigurations.length - 1].charmCount
  }

  get currentConfiguration () {
    const charmCount = this.selectedCharms.length

    const sortedConfigurations = this.configurationProps.sort(
      (a, b) => a.charmCount - b.charmCount,
    )

    const currentConfiguration = sortedConfigurations.find(
      (props) => props.charmCount >= charmCount,
    )

    if (!currentConfiguration) return this.configurationProps[0]

    return currentConfiguration
  }
}

class PreviewCanvas {
  constructor () {
    this.charms = []
  }

  async render () {
    if (!this.stage) {
      this.container = document.querySelector(
        '[data-charms-form-el="previewContainer"]',
      )

      this.containerWidth =
        document.querySelector('.prd-Detail_Form').clientWidth - 40

      this.stage = new window.Konva.Stage({
        container: this.container,
        width: this.containerWidth,
        height: 80,
        draggable: false,
      })

      this.bindDragDrop()
    }

    if (this.charmLayer) {
      this.charmLayer.remove()
    }

    this.charmLayer = new window.Konva.Layer()

    this.charms.forEach((charm, i) => {
      this.generateCharm(charm, i)
    })

    this.stage.add(this.charmLayer)
  }

  async generateCharm (charm, index) {
    const img = this.createImage(charm.featured_image)

    const charmWidth = Math.min(
      this.containerWidth / this.charms.length - 10,
      55,
    )

    const size = charmWidth
    const gap = 10

    const x = (size + gap) * index + 1

    const charmContainer = new window.Konva.Circle({
      x: size / 2,
      y: size / 2,
      radius: size / 2,
      stroke: '#000',
      strokeWidth: 1,
    })

    const charmImage = new window.Konva.Image({
      image: img,
      x: 6,
      y: 6,
      width: size - 12,
      height: size - 12,
      charmIndex: index,
    })

    const charmGroup = new window.Konva.Group({
      draggable: true,
      x: x + size / 2,
      y: size / 2,
      offsetX: size / 2,
      offsetY: size / 2,
      charmIndex: index,
      name: 'charmGroup',
    })

    const crossContainer = new window.Konva.Group({
      x: size - 9.5,
      y: 9.5,
    })

    const crossCircle = new window.Konva.Circle({
      x: 0,
      y: 0,
      radius: 9.5,
      fill: '#000',
    })

    const cross = new window.Konva.Path({
      data: `M1 1L8.00011 8.00011 M8 1L0.999789 8`,
      x: -4.5,
      y: -4.5,
      stroke: '#fff',
      strokeWidth: 1,
    })

    charmGroup.add(charmImage)

    if (charm.title) {
      const charmTitle = new window.Konva.Text({
        text: charm.title,
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: size + 10,
        width: size,
        fontSize: 10,
        lineHeight: 1.5,
      })

      charmGroup.add(charmTitle)
    }

    charmGroup.add(charmContainer)
    charmGroup.add(crossContainer)
    crossContainer.add(crossCircle)
    crossContainer.add(cross)

    charmGroup.dragBoundFunc(function (pos) {
      const minPos = size / 2 + 1
      const maxPos = 410 - (size / 2 + 1)
      const posX = Math.min(Math.max(minPos, pos.x), maxPos)

      return {
        x: posX,
        y: this.absolutePosition().y,
      }
    })

    crossContainer.on('click tap', this.onCrossClick)
    crossContainer.on('mouseenter', this.onCrossHover)
    crossContainer.on('mouseleave', this.onCrossBlur)

    charmGroup.on('mouseenter', this.onCharmHover)
    charmGroup.on('mouseleave', this.onCharmBlur)

    this.charmLayer.add(charmGroup)
  }

  createImage (url) {
    const image = new Image()
    image.crossOrigin = ''
    image.src = url
    return image
  }

  onCrossHover () {
    this.getChildren((node) => node.getClassName() === 'Circle')[0].to({
      fill: '#ad2a2a',
      duration: 0.15,
    })
    document.body.style.cursor = 'pointer'
  }

  onCrossBlur () {
    this.getChildren((node) => node.getClassName() === 'Circle')[0].to({
      fill: '#202020',
      duration: 0.15,
    })
    document.body.style.cursor = 'default'
  }

  onCharmHover () {
    document.body.style.cursor = 'pointer'
  }

  onCharmBlur () {
    document.body.style.cursor = 'default'
  }

  onCrossClick () {
    const index = this.findAncestor('Group', false).attrs.charmIndex

    document.dispatchEvent(
      new CustomEvent('preview:remove', {
        detail: { index },
      }),
    )
  }

  bindDragDrop () {
    this.tempLayer = new window.Konva.Layer()
    this.stage.add(this.tempLayer)

    let currentCharm
    let targetCharm
    let initialX, initialY

    this.stage.on('dragstart', (e) => {
      if (e.target.attrs.container) {
        return
      }

      currentCharm = e.target.findAncestor('.charmGroup', true)
      initialX = currentCharm.attrs.x
      initialY = currentCharm.attrs.y

      this.tempLayer.zIndex(2)

      currentCharm.moveTo(this.tempLayer)

      this.charmLayer.draw()
    })

    this.stage.on('dragmove', (e) => {
      if (e.target.attrs.container) {
        return
      }
      const pos = this.stage.getPointerPosition()
      const newTargetCharm = this.charmLayer
        .getIntersection(pos)
        ?.findAncestor('.charmGroup', true)
      if (targetCharm && !newTargetCharm) {
        targetCharm.to({
          scaleX: 1,
          scaleY: 1,
          duration: 0.15,
        })
      }
      if (newTargetCharm && newTargetCharm !== targetCharm) {
        newTargetCharm.to({
          scaleX: 0.85,
          scaleY: 0.85,
          duration: 0.15,
        })
      }
      targetCharm = newTargetCharm
    })

    this.stage.on('dragend', (e) => {
      if (e.target.attrs.container) {
        return
      }

      if (targetCharm) {
        currentCharm.to({
          x: targetCharm.attrs.x,
          y: targetCharm.attrs.y,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })

        targetCharm.to({
          x: initialX,
          y: initialY,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })

        this.swapCharms(currentCharm, targetCharm)
      } else {
        currentCharm.to({
          x: initialX,
          y: initialY,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })
      }

      currentCharm.moveTo(this.charmLayer)
      currentCharm = null
      targetCharm = null
    })
  }

  swapCharms = (charm1, charm2) => {
    const charm1Index = charm1.attrs.charmIndex
    const charm2Index = charm2.attrs.charmIndex

    const temp = this.charms[charm1Index]
    this.charms[charm1Index] = this.charms[charm2Index]
    this.charms[charm2Index] = temp

    charm1.attrs.charmIndex = charm2Index
    charm2.attrs.charmIndex = charm1Index

    document.dispatchEvent(
      new CustomEvent('preview:reorder', {
        detail: { charms: this.charms },
      }),
    )
  }
}

class CharmsCanvas {
  constructor () {
    this.charms = []
    this.configuration = {}
  }

  async render () {
    if (!this.stage) {
      this.container = document.querySelector(
        '[data-charms-form-external-el="image"]',
      )

      this.stage = new window.Konva.Stage({
        container: this.container,
        width: this.containerWidth,
        height: this.containerWidth,
        draggable: false,
      })

      this.bindDragDrop()
    }

    if (this.backgroundLayer) {
      this.backgroundLayer.remove()
    }

    this.backgroundLayer = new window.Konva.Layer()

    await this.generateBackground(this.configuration)

    this.stage.add(this.backgroundLayer)

    if (this.charmLayer) {
      this.charmLayer.remove()
    }

    this.charmLayer = new window.Konva.Layer()

    this.charms.forEach((charm, i) => {
      this.generateCharm(charm, this.configuration.placements[i], i)
    })

    this.stage.add(this.charmLayer)
  }

  async generatePreview () {
    if (!this.stage) return

    if (this.generatingPreview) {
      window.clearTimeout(this.previewTimer)
    }

    this.generatingPreview = true

    this.previewTimer = window.setTimeout(() => {
      const preview = this.stage.toDataURL({ mimeType: 'image/jpeg' })

      const form = document.querySelector('charms-form form')
      let previewInput = form.querySelector('[data-preview-image]')
      if (!previewInput) {
        previewInput = document.createElement('input')
        previewInput.setAttribute('type', 'hidden')
        previewInput.setAttribute('name', '_preview_image')
        previewInput.setAttribute('data-preview-image', '')
        form.appendChild(previewInput)
      }

      previewInput.value = preview

      this.generatingPreview = false
    }, 1000)
  }

  async generateBackground (props) {
    const imageAttribute = this.useTempImage
      ? props.tempBackgroundImage
      : props.backgroundImage

    const backgroundImg = await this.createImage(imageAttribute)

    const backgroundColour = new window.Konva.Rect({
      x: 0,
      y: 0,
      width: this.stage.width(),
      height: this.stage.height(),
      fill: '#fcfafa',
    })

    const backgroundImage = new window.Konva.Image({
      image: backgroundImg,
      x: 0,
      y: 0,
      width: this.stageWidth,
      height: this.stageWidth,
      draggable: false,
    })

    this.backgroundLayer.add(backgroundColour)
    this.backgroundLayer.add(backgroundImage)
  }

  async generateCharm (charm, placement, index) {
    const img = this.createImage(charm.visualiser_image, this.loaderTimer)

    const size = this.stageWidth / 100

    const x = size * placement.x
    const y = size * placement.y

    const imageWidth = 7 * size * placement.scale
    const imageHeight = 7 * size * placement.scale
    const offsetX = imageWidth * 0.5

    const charmImage = new window.Konva.Image({
      image: img,
      x: 0,
      y: 0,
      width: imageWidth,
      height: imageHeight,
      charmIndex: index,
      name: 'charmImage',
    })

    const hitBox = new window.Konva.Rect({
      width: imageWidth,
      height: imageWidth,
    })

    const charmGroup = new window.Konva.Group({
      draggable: true,
      x,
      y,
      rotation: placement.rotation,
      offsetX,
      charmIndex: index,
    })

    charmGroup.add(hitBox)
    charmGroup.add(charmImage)

    charmGroup.on('mouseenter', this.onCharmHover)
    charmGroup.on('mouseleave', this.onCharmBlur)

    this.charmLayer.add(charmGroup)
  }

  createImage (url, loaderTimer) {
    const image = new Image()
    image.crossOrigin = ''
    image.src = url
    image.addEventListener('load', () => {
      this.generatePreview()
    })
    return image
  }

  bindDragDrop () {
    this.tempLayer = new window.Konva.Layer()
    this.stage.add(this.tempLayer)

    let currentCharm
    let targetCharm
    let initialX, initialY, initialRotation

    this.stage.on('dragstart', (e) => {
      if (e.target.attrs.container) {
        return
      }
      currentCharm = e.target
      initialX = currentCharm.attrs.x
      initialY = currentCharm.attrs.y
      initialRotation = currentCharm.attrs.rotation

      this.tempLayer.zIndex(2)

      currentCharm.moveTo(this.tempLayer)

      this.charmLayer.draw()
    })

    this.stage.on('dragmove', (e) => {
      if (e.target.attrs.container) {
        return
      }
      const pos = this.stage.getPointerPosition()
      const newTargetCharm = this.charmLayer.getIntersection(pos)?.parent
      if (targetCharm && !newTargetCharm) {
        targetCharm.to({
          scaleX: 1,
          scaleY: 1,
          duration: 0.15,
        })
      }
      if (newTargetCharm && newTargetCharm !== targetCharm) {
        newTargetCharm.to({
          scaleX: 1.15,
          scaleY: 1.15,
          duration: 0.15,
        })
      }
      targetCharm = newTargetCharm
    })

    this.stage.on('dragend', (e) => {
      if (e.target.attrs.container) {
        return
      }

      if (targetCharm) {
        currentCharm.to({
          x: targetCharm.attrs.x,
          y: targetCharm.attrs.y,
          rotation: targetCharm.attrs.rotation,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })

        targetCharm.to({
          x: initialX,
          y: initialY,
          rotation: initialRotation,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })

        this.swapCharms(currentCharm, targetCharm)
      } else {
        currentCharm.to({
          x: initialX,
          y: initialY,
          scaleX: 1,
          scaleY: 1,
          duration: 0.35,
        })
      }

      currentCharm.moveTo(this.charmLayer)
      currentCharm = null
      targetCharm = null
    })
  }

  onCharmHover () {
    this.to({
      scaleX: 1.15,
      scaleY: 1.15,
      duration: 0.15,
    })
    document.body.style.cursor = 'pointer'
  }

  onCharmBlur () {
    this.to({
      scaleX: 1,
      scaleY: 1,
      duration: 0.15,
    })
    document.body.style.cursor = 'default'
  }

  swapCharms = (charm1, charm2) => {
    const charm1Index = charm1.attrs.charmIndex
    const charm2Index = charm2.attrs.charmIndex

    const temp = this.charms[charm1Index]
    this.charms[charm1Index] = this.charms[charm2Index]
    this.charms[charm2Index] = temp

    charm1.attrs.charmIndex = charm2Index
    charm2.attrs.charmIndex = charm1Index

    document.dispatchEvent(
      new CustomEvent('visualiser:reorder', {
        detail: { charms: this.charms },
      }),
    )
  }

  get stageWidth () {
    return this.stage.width()
  }

  get containerWidth () {
    const containerOuter = this.container.closest('.prd-Media-charms')
    const containerInner = this.container.closest('.prd-Media_Charms')

    const containerVisibility = containerInner.getAttribute('aria-hidden')

    containerOuter.setAttribute('aria-hidden', 'false')
    containerInner.setAttribute('aria-hidden', 'false')

    const width = this.container.clientWidth
    containerOuter.setAttribute('aria-hidden', 'true')
    containerInner.setAttribute('aria-hidden', containerVisibility)

    return width
  }
}

if (!customElements.get('charms-form')) {
  customElements.define('charms-form', CharmsForm)
}
